/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Agents_Use_2_ValueInputs */

const en_svc_agents_use_2_value = /** @type {(inputs: Svc_Agents_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound leads are scored against your criteria and routed to the right person with context.`)
};

const lv_svc_agents_use_2_value = /** @type {(inputs: Svc_Agents_Use_2_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ienākošie pieteikumi tiek novērtēti pēc Jūsu kritērijiem un nodoti īstajam cilvēkam kopā ar kontekstu.`)
};

/**
* | output |
* | --- |
* | "Inbound leads are scored against your criteria and routed to the right person with context." |
*
* @param {Svc_Agents_Use_2_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_agents_use_2_value = /** @type {((inputs?: Svc_Agents_Use_2_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Agents_Use_2_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_agents_use_2_value(inputs)
	return en_svc_agents_use_2_value(inputs)
});